import { computed, inject, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from '../../core';


/**
 * This service handles i18n data of the datepicker component.
 */
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

	private readonly langSrv = inject(LanguageService);

	weekdays = computed<string[]>(() => this.langSrv.labels().WEEKDAYS);
	months = computed<string[]>(() => this.langSrv.labels().MONTHS);


	override getWeekdayLabel(weekday: number, width?: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined>): string {
		return this.weekdays()[weekday - 1];
	}

	override getMonthShortName(month: number, year?: number): string {
		return this.months()[month - 1];
	}

	override getMonthFullName(month: number, year?: number): string {
		return this.getMonthShortName(month);
	}

	override getDayAriaLabel(date: NgbDateStruct): string {
		return `${date.day}-${date.month}-${date.year}`;
	}

}